import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';

export function loadFoundation(): void {
    Foundation.addToJquery($);
    Foundation.plugin(Tooltip, 'Tooltip');
    console.log('foundation loaded');
}

